import { render, staticRenderFns } from "./CurrentUsers.vue?vue&type=template&id=09064abc&"
import script from "./CurrentUsers.vue?vue&type=script&lang=js&"
export * from "./CurrentUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports